import React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import LandingPage from '../../Pages/LandingPage/LandingPage';

const RootRoute = () => useIsAuthenticated() ? <Navigate to="/home" replace /> : <LandingPage />;

export default RootRoute;
